import React from 'react'
import { Box } from '@mui/material'
import { State, PartialAction, Position } from 'src/types'
import { BaseSetter } from 'src/features/atoms/glove/us/Components/BaseSetter'
import { ColorSetter } from 'src/features/atoms/glove/us/Components/ColorSetter'
import { EmbroiderySetter } from 'src/features/atoms/glove/us/Components/EmbroiderySetter'
import { SettingButtons } from 'src/Components/Domain/SettingButtons'
import { SimulationConfirmDialog } from 'src/features/simulationConfirm/Components/SimulationConfirmDialog'
import { SettingTabs } from 'src/Components/Domain/SettingTabs'

type Props = {
  state: State
  figurePanelNum: number
  dispatch: React.Dispatch<PartialAction>
}

export const Setters: React.FC<Props> = ({ state, figurePanelNum, dispatch }) => {
  const [selectedIndex, setSelectedIndex] = React.useState(0)
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false)
  const position = state?.baseModel?.position.toString() as Position
  const handleDialogOpen = () => setIsDialogOpen(true)
  const handleDialogClose = () => setIsDialogOpen(false)
  return (
    <Box border={'solid 1px #3f51b5'}>
      <SettingTabs {...{ selectedIndex, setSelectedIndex }} />
      <BaseSetter {...{ state, selectedIndex, position, dispatch }} />
      <ColorSetter {...{ state, selectedIndex, figurePanelNum, position, dispatch }} />
      <EmbroiderySetter {...{ selectedIndex, dispatch }} embroideries={state.embroideries} productNumber={state.baseModel.productNumber} />
      <SettingTabs {...{ selectedIndex, setSelectedIndex }} />
      <SettingButtons {...{ handleDialogOpen }} />
      <SimulationConfirmDialog {...{ state, position, isDialogOpen, handleDialogClose, dispatch }} brand={'atoms'} />
    </Box>
  )
}
